const additionalPropertySurcharge = 5;
const additionalNonUKSurcharge = 2;
const additionalScotlandPropertySurcharge = 6;
const percent = String.fromCharCode(37);

// Countries object
const countries = {
  ENGLAND: 'england',
  SCOTLAND: 'scotland',
  WALES: 'wales',
  IRELAND: 'ireland'
};

// Ireland initial slab rates
const mortageCountryScheme = [{
  value: 'all',
  label: 'Choose Council'
}, {
  value: '325000_Carlow',
  label: 'Carlow County Council'
}, {
  value: '325000_Cavan',
  label: 'Cavan County Council'
}, {
  value: '325000_Clare',
  label: 'Clare County Council'
}, {
  value: '475000_CorkCity',
  data_apt: "500000",
  label: 'Cork City Council'
}, {
  value: '425000_CorkContry',
  label: 'Cork County Council'
}, {
  value: '325000_Donegal',
  label: 'Donegal County Council'
}, {
  value: '475000_DublinCity',
  data_apt: "500000",
  label: 'Dublin City Council'
}, {
  value: '475000_Dublin_county',
  data_apt: "500000",
  label: 'Dublin South County Council'
}, {
  value: '475000_Dun',
  data_apt: "500000",
  label: 'Dun Laoghaire-Rathdown County Council'
}, {
  value: '475000_Fingal',
  data_apt: "500000",
  label: 'Fingal County Council'
}, {
  value: '425000_GalwayCity',
  data_apt: "450000",
  label: 'Galway City Council'
}, {
  value: '375000_Galway_country',
  label: 'Galway County Council'
}, {
  value: '325000_Kerry',
  label: 'Kerry County Council'
}, {
  value: '425000_Kildare',
  label: 'Kildare County Council'
}, {
  value: '375000_Kilkenny',
  label: 'Kilkenny County Council'
}, {
  value: '350000_Laois',
  label: 'Laois County Council'
}, {
  value: '325000_Leitrim',
  label: 'Leitrim County Council'
}, {
  value: '375000_Limerick',
  data_apt: "450000",
  label: 'Limerick City and County Council'
}, {
  value: '325000_Longford',
  label: 'Longford County Council'
}, {
  value: '375000_Louth',
  label: 'Louth County Council'
}, {
  value: '325000_Mayo',
  label: 'Mayo County Council'
}, {
  value: '375000_Meath',
  label: 'Meath County Council'
}, {
  value: '325000_Monaghan',
  label: 'Monaghan County Council'
}, {
  value: '325000_Offaly',
  label: 'Offaly County Council'
}, {
  value: '325000_Roscommon',
  label: 'Roscommon County Council'
}, {
  value: '325000_Sligo',
  label: 'Sligo County Council'
}, {
  value: '325000_Tipperary',
  label: 'Tipperary County Council'
}, {
  value: '350000_Waterford',
  data_apt: "450000",
  label: 'Waterford City and County Council'
}, {
  value: '375000_Westmeath',
  data_apt: "450000",
  label: 'Westmeath County Council'
}, {
  value: '325000_Wexford',
  label: 'Wexford County Council'
}, {
  value: '475000_Wicklow',
  label: 'Wicklow County Council'
}];

// Ireland initial slab rates
const mortagePropertyType = [{
  value: 'all',
  label: 'Choose Type'
}, {
  value: 'house',
  label: 'House'
}, {
  value: 'apartment',
  label: 'Apartment'
}];

// Property Type object
const propertyTypes = {
  COMMERCIAL: 'commercial',
  RESIDENTIAL: 'residential'
};

// Buyer Type object
const buyerTypes = {
  FIRST_TIME: 'first',
  MOVING_HOUSE: 'home',
  INVESTOR: 'investor',
  OVERSEAS: 'overseas'
};

// Ireland initial slab rates
const ireland = [{
  upto: 1000000,
  rate: 1
}, {
  upto: 'end',
  rate: 2
}];

// Scotland initial slab rates
const scotland = [{
  upto: 250000,
  rate: 2,
  additionalScotlandPropertySurcharge
}, {
  upto: 325000,
  rate: 5,
  additionalScotlandPropertySurcharge
}, {
  upto: 750000,
  rate: 10,
  additionalScotlandPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalScotlandPropertySurcharge
}];
const sdltBands = {
  [propertyTypes.COMMERCIAL]: {
    [countries.ENGLAND]: [{
      upto: 150000,
      rate: 0
    }, {
      upto: 250000,
      rate: 2
    }, {
      upto: 'end',
      rate: 5
    }],
    [countries.WALES]: [{
      upto: 150000,
      rate: 0
    }, {
      upto: 250000,
      rate: 1
    }, {
      upto: 1000000,
      rate: 5
    }, {
      upto: 'end',
      rate: 6
    }],
    [countries.SCOTLAND]: [{
      upto: 150000,
      rate: 0
    }, {
      upto: 250000,
      rate: 1
    }, {
      upto: 'end',
      rate: 5
    }],
    ireland
  },
  [propertyTypes.RESIDENTIAL]: {
    [buyerTypes.FIRST_TIME]: {
      [countries.ENGLAND]: {
        thresholds: [{
          upto: 300000,
          rate: 0
        }, {
          upto: 500000,
          rate: 5
        }, {
          upto: 625000,
          rate: 5
        }],
        limit: 500000
      },
      [countries.SCOTLAND]: {
        thresholds: [{
          upto: 175000,
          rate: 0,
          additionalScotlandPropertySurcharge
        }, ...scotland],
        limit: -1
      }
    },
    [buyerTypes.OVERSEAS]: {
      [countries.ENGLAND]: {
        thresholds: [{
          upto: 250000,
          rate: 2
        }, {
          upto: 925000,
          rate: 7
        }, {
          upto: 1500000,
          rate: 12
        }, {
          upto: 'end',
          rate: 14
        }],
        limit: -1
      }
    },
    [countries.ENGLAND]: [{
      upto: 125000,
      rate: 0,
      additionalPropertySurcharge
    }, {
      upto: 250000,
      rate: 2,
      additionalPropertySurcharge
    }, {
      upto: 925000,
      rate: 5,
      additionalPropertySurcharge
    }, {
      upto: 1500000,
      rate: 10,
      additionalPropertySurcharge
    }, {
      upto: 'end',
      rate: 12,
      additionalPropertySurcharge
    }],
    [countries.WALES]: [{
      upto: 180000,
      rate: 0,
      additionalPropertySurcharge
    }, {
      upto: 250000,
      rate: 3.5,
      additionalPropertySurcharge
    }, {
      upto: 400000,
      rate: 5,
      additionalPropertySurcharge
    }, {
      upto: 750000,
      rate: 7.5,
      additionalPropertySurcharge
    }, {
      upto: 1500000,
      rate: 10,
      additionalPropertySurcharge
    }, {
      upto: 'end',
      rate: 12,
      additionalPropertySurcharge
    }],
    [countries.SCOTLAND]: [{
      upto: 145000,
      rate: 0,
      additionalScotlandPropertySurcharge
    }, ...scotland],
    ireland
  }
};
const {
  limit: englandFirstTimeLimit
} = sdltBands[propertyTypes.RESIDENTIAL][buyerTypes.FIRST_TIME][countries.ENGLAND];
const comments = {
  firstTimeWales: 'there is no separate first time buyer exemption in Wales',
  under40kUKInvestor: 'all transactions below 40k in UK are exempt from ',
  UKInvestor: `${additionalPropertySurcharge + percent} surcharge is applied`,
  firstTimeEnglandOverLimit: `properties over £${englandFirstTimeLimit} do not attract first time buyer relief`,
  EMPTY: ''
};
const taxNames = {
  [countries.ENGLAND]: {
    long: 'stamp duty land tax',
    short: 'SDLT'
  },
  [countries.IRELAND]: {
    long: 'stamp duty',
    short: 'stamp duty'
  },
  [countries.SCOTLAND]: {
    long: 'land and buildings tax',
    short: 'LBTT'
  },
  [countries.WALES]: {
    long: 'land transaction tax',
    short: 'LTT'
  }
};
const config = {
  sdltBands,
  countries,
  propertyTypes,
  buyerTypes,
  comments,
  englandFirstTimeLimit,
  taxNames,
  mortageCountryScheme,
  mortagePropertyType
};
module.exports = config;